/**
 * Regex patterns for input validation
 */
export const REGEX_PATTERNS = {
  // Matches decimal numbers (e.g., 56.23, 48, 100.5)
  DECIMAL_NUMBER: /^[0-9]+([.][0-9]+)?$/,
  // Matches numbers between 100 and 400
  RANGE_100_TO_400: /\b([1-3][0-9][0-9]|400)\b/,
  // Matches numbers between 0 and 500
  RANGE_0_TO_500: /\b([0-9]|[1-9][0-9]|[1-4][0-9][0-9]|500)\b/,
};

/**
 * Model options for the simulator with descriptions
 */
export const MODEL_OPTIONS = [
  { 
    value: 1, 
    label: 'Antes del año 2000',
    description: 'Pruebas con escala de 100 a 400 puntos',
    helperText: 'Ingrese un número entre 100 y 400. Ejemplo: 250',
  },
  { 
    value: 2, 
    label: 'Entre año 2000 y segundo periodo 2011',
    description: 'Promedio de puntajes por materia (0-100 cada una)',
    helperText: 'Ingrese los puntajes separados por coma. Ejemplo: 56.23, 48.15, 42.26',
  },
  { 
    value: 3, 
    label: 'Entre primer periodo de 2012 y primer periodo 2014',
    description: 'Requiere recalificación del ICFES (escala 0-500)',
    helperText: 'Ingrese el puntaje recalificado (0-500). Ejemplo: 320',
  },
  { 
    value: 4, 
    label: 'Del segundo periodo de 2014 en adelante',
    description: 'Puntaje global publicado por el ICFES (escala 0-500)',
    helperText: 'Ingrese el puntaje global (0-500). Ejemplo: 285',
  },
];

/**
 * Legends for each model type
 */
export const MODEL_LEGENDS = {
  1: 'Ingrese el valor del resultado en la escala de 100 a 400',
  2: 'Ingrese el valor de las pruebas separados por coma (,), ejemplo: 56.23, 48.15, 42.26, 64.23, 42.26',
  3: 'Ingrese puntaje recalificado por el icfes (escala de 0 a 500)',
  4: 'Ingrese puntaje publicado por el icfes (escala de 0 a 500)',
};

/**
 * Helper text for each model type
 */
export const MODEL_HELPER_TEXT = {
  0: 'Seleccione primero un periodo de realización',
  1: 'Ejemplo: 250, 300, 350',
  2: 'Ejemplo: 56.23, 48.15, 42.26, 64.23, 42.26',
  3: 'Ejemplo: 320, 400, 450',
  4: 'Ejemplo: 285, 350, 420',
};

/**
 * Error messages
 */
export const ERROR_MESSAGES = {
  INVALID_RANGE_100_400: 'Por favor ingrese numero entre 100 y 400',
  INVALID_RANGE_0_500: 'Por favor ingrese numero entre 0 y 500',
  INVALID_COMMA_SEPARATED: 'Por favor ingrese el valor de las pruebas separados por coma (,)',
};

/**
 * Table data for conversion information
 */
export const CONVERSION_TABLE_DATA = [
  {
    period: 'Del segundo periodo de 2014 en adelante',
    scale: 'Cero (0) a quinientos (500) puntos',
    conversion: 'Se calcula dividiendo el puntaje total entre 5',
  },
  {
    period: 'Entre el primer periodo de 2012 y el primer periodo de 2014.',
    scale: 'Cero (0) a quinientos (500) puntos. En este caso se debe solicitar recalificación realizada por el ICFES.',
    conversion: 'Se mantiene el puntaje global obtenido de acuerdo con la recalificación realizada por el ICFES y se divide entre 5',
  },
  {
    period: 'Entre el año 2000 y el segundo periodo de 2011',
    scale: 'Cero (0) a cien (100) en cada una de las pruebas evaluadas.',
    conversion: 'Se promedian los puntajes.',
  },
  {
    period: 'Pruebas realizadas antes del año 2000.',
    scale: 'Cien (100) a cuatrocientos (400) puntos.',
    conversion: 'Se calcula teniendo en cuenta la fórmula (puntaje - 100) / 3.',
  },
];

/**
 * External links
 */
export const EXTERNAL_LINKS = {
  ICFES_RESULTS: 'https://icfesinteractivo.gov.co/resultados/res_est/sniee_log_per.jsp',
  UNIVERSITY: 'https://unicartagena.edu.co/',
};
